import { types, getEnv, Instance } from 'mobx-state-tree';
import { RightColumnBanners } from '../dtos/rightColumnBannerDtos';
import { ICommonAppEnvWithSBBaseApi } from './index';
import { observable } from 'mobx';

export const RightColumnBannerItemModel = types.model({
    id: types.number,
    title: types.string,
    imgUrl: types.maybeNull(types.string),
    linkUrl: types.maybeNull(types.string),
    width: types.maybeNull(types.number),
    height: types.maybeNull(types.number),
    asNewWindow: types.maybeNull(types.boolean)
});

export const RightColumnBannerStore = types
    .model({
        items: types.array(RightColumnBannerItemModel),
    })
    .actions(self => {
        const env = getEnv<ICommonAppEnvWithSBBaseApi>(self);

        const processData = (data: RightColumnBanners) => {
            try {
                self.items = observable(data.Banners.map((item) => {
                    return RightColumnBannerItemModel.create(<Instance<typeof RightColumnBannerItemModel>>{
                        id: item.Id,
                        title: item.Title,
                        imgUrl: item.ImgUrl,
                        linkUrl: item.LinkUrl,
                        width: item.Width,
                        height: item.Height,
                        asNewWindow: item.AsNewWindow
                    });
                }));
            } catch (error) {
                env.loggingService.error(error);
            } finally {
            }
        }
        return {
            processData
        };
    });
